import { render, staticRenderFns } from "./CouponIssueTequan.vue?vue&type=template&id=a8581fb4&scoped=true&"
import script from "./CouponIssueTequan.vue?vue&type=script&lang=js&"
export * from "./CouponIssueTequan.vue?vue&type=script&lang=js&"
import style0 from "./CouponIssueTequan.vue?vue&type=style&index=0&id=a8581fb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8581fb4",
  null
  
)

export default component.exports